export interface JobCredentials {
    userName: string;
    password: string;
    domain?: string;
}
